import { lazy } from "react";

// project import
import Loadable from "@shared/components/Loadable";
import MinimalLayout from "layout/MinimalLayout";

// AuthApp - using new modular structure
const AuthLogin    = Loadable(lazy(() => import("@apps/AuthApp/pages/Login")));
const AuthRegister = Loadable(lazy(() => import("@apps/AuthApp/pages/Register")));
// SSO callback
const AuthCallback = Loadable(lazy(() => import("@apps/AuthApp/pages/AuthCallback")));

// CompanyApp - using new modular structure
const PrivacyPolicy    = Loadable(lazy(() => import("@apps/CompanyApp/pages/PrivacyPolicy")));
const TermsConditions  = Loadable(lazy(() => import("@apps/CompanyApp/pages/TermsAndConditions")));
const ContactUs        = Loadable(lazy(() => import("@apps/CompanyApp/pages/ContactUs")));

// Public dashboard — no auth required
const PublicDashboard  = Loadable(lazy(() => import("@apps/DashboardApp/pages/PublicDashboard")));

const UserConfig           = Loadable(lazy(() => import("@apps/ConfigurationApp/pages/UserConfig")));
const AccessControl        = Loadable(lazy(() => import("@apps/ConfigurationApp/pages/AccessControl")));
const WorkspaceType       = Loadable(lazy(() => import("@apps/ConfigurationApp/pages/WorkspaceType")));
const WorkspaceManagement = Loadable(lazy(() => import("@apps/ConfigurationApp/pages/WorkspaceManagement")));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = () => {
  return {
    path: "/",
    element: <MinimalLayout />,
    children: [
      { path: "/",                 element: <AuthLogin /> },
      { path: "/login",            element: <AuthLogin /> },
      { path: "/api/register-admin", element: <AuthRegister /> },
      { path: "/privacy-policy",   element: <PrivacyPolicy /> },
      { path: "/terms-conditions", element: <TermsConditions /> },
      { path: "/contact-us",       element: <ContactUs /> },
      { path: "/auth/callback",    element: <AuthCallback /> },
      { path: "/public-dashboard", element: <PublicDashboard /> },

      { path: "/setup/workspace-type",   element: <WorkspaceType /> },
      { path: "/setup/workspace",        element: <WorkspaceManagement /> },
      { path: "/setup/user-config",      element: <UserConfig /> },
      { path: "/setup/access-control",   element: <AccessControl /> },
    ],
  };
};

export default LoginRoutes;